module.exports = __webpack_public_path__ + "static/media/noun_clock_2593810.b2782ef3.svg";